let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8A35j")).then(() => parcelRequire('MUFrj'));